import React from 'react'
import { useNavigate } from 'react-router-dom'

const ProfileModal = ({ show, onClose, message, hideCancel = false, hideClose = false }) => {
  const navigate = useNavigate();

  if (!show) return null;
  
  const handleCompleteProfile = () => {
    const companyId = localStorage.getItem("companyId");
    if(companyId){
      navigate('/company-profile'); 
    } else{navigate('/myprofile');}
    
  };
  
  return (
    <div 
      className="modal" 
      style={{ 
        display: show ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1050
      }}
      onClick={onClose}
    >
      <div 
        className="modal-dialog modal-dialog-centered"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header border-bottom-0">
          {!hideClose && (<button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
            ></button>)}
          </div>
          <div className="modal-body text-center pb-4">
            <div className="position-relative d-inline-block mb-4">
             
              <i className="fas fa-user-circle fa-5x text-primary"></i>
            
              <div className="position-absolute" style={{ top: '0', right: '-10px' }}>
                <i className="fas fa-times-circle fa-2x text-danger"></i>
              </div>
            </div>
            
            <h5 className="modal-title mb-3">Profile Incomplete</h5>
            <p className="text-muted mb-4">{message || "Please complete your profile to continue"}</p>
            
            <div className="d-flex justify-content-center gap-2">
              <button 
                type="button" 
                className="btn btn-primary px-4"
                onClick={handleCompleteProfile}
              >
                Complete Profile
              </button>
              {!hideCancel && (<button 
                type="button" 
                className="btn btn-outline-secondary px-4" 
                onClick={onClose}
              >
                Cancel
              </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileModal